export const CHIP_BASE =
  "rounded-full border text-sm font-medium outline-hidden cursor-pointer transition-colors disabled:cursor-default focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-border-brand-solid";

export const CHIP_SELECTED =
  "border-border-brand-solid bg-bg-brand-solid text-text-white";

export const CHIP_NEUTRAL =
  "border-border-primary text-text-secondary hover:bg-bg-secondary";

export const CHIP_POSITIVE =
  "border-border-success text-text-success-primary hover:bg-bg-success-secondary";

export const CHIP_NEGATIVE =
  "border-border-error text-text-error-primary hover:bg-bg-error-secondary";
